// extracted by mini-css-extract-plugin
export default {"form_other":"passwordForgot_form_other__z26MN"};